import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CircularSpinner from "../../../components/CircularSpinner";
import { declineChallenge, generateRandom } from "../../../redux/actions/quiz";
import { IKImage } from "imagekitio-react";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import { useEffect } from "react";
import {
  getCertificate,
  getCertificateLink,
} from "../../../redux/actions/certificate";
import { getLinkFromBuffer,downloadCertificate } from "../../../utils/generateCertificate";
import { setShowCompleteChallengeBanner, setShowExtendChallengeBanner, setShowStartChallengeBanner } from "../../../redux/actions/adBanner";

export default function OneDayChallenge({
  nextLesson,
  createChallengeHandler,
  challengeSpinner,
  setChallengeModal,
  setChallengePopover,
  setUserAlreadyTakenChallenge,
  oneDayScrollRef,
  setOneDayChallengeActivity
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { course_slug, skill_slug, lessonId, mskill_slug } = useParams();
  const userId = useSelector((store) => store?.profileDetails?.id);
  const name = useSelector((store) => store?.profileDetails?.name);
//   const [declineModal, setDeclineChallengeModal] = useState(false)
  const [stepOne, setStepOne] = useState(false);
  const [stepTwo, setStepTwo] = useState(false);
  const email = useSelector((store) => store?.profileDetails?.email);
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const [certificateLink, setCertificateLink] = useState("");
  const [randomNumber , setRandomNumber] = useState("");
  const [challengeSpinner1, setChallengeSpinner1] = useState(false);
  const [challengeSpinner2 , setChallengeSpinner2] = useState(false);

  useEffect(() => {
    dispatch(
      getCertificate(userId, mskill_slug, async (data) => {
        dispatch(
          getCertificateLink(
            data?.unique_certificate_id,
            "image_png",
            (link) => {
             
              setCertificateLink(link);
            }
          )
        );
      })
    );
    dispatch(generateRandom((successObj)=> { setRandomNumber(successObj)}));
    setTimeout(() => {
      if(oneDayScrollRef?.current){
        oneDayScrollRef?.current?.scrollIntoView()
      }
    }, 1000)
    dispatch(setShowStartChallengeBanner(true));
    dispatch(setShowCompleteChallengeBanner(true));
    dispatch(setShowExtendChallengeBanner(true));
  }, [stepOne]);
 
  if (!stepOne && !stepTwo) {
    return (
      <div
        className="flex h-full w-full flex-col items-center justify-evenly py-5 text-center backdrop-blur-lg"
        style={{ zIndex: 4 }} ref={oneDayScrollRef}
      >
        <div className="text-lg md:text-2xl font-bold">
        That’s a great start {user_name?.split(" ")?.[0]}!
        </div>
        <div className="text-lg md:text-2xl font-bold -mt-1">
        Want your certificate for free?
        </div>
        { certificateLink && <div className="relative mt-4 w-3/5 md:w-1/2">
          <img src={certificateLink} className="w-full" alt="certificate link" ></img>
          <img
            urlEndpoint="https://assets.learntube.ai/files/"
            src={
              "https://assets.learntube.ai/files/Content_player/Certificate_overlay.png?ik-sdk-version=javascript-1.4.3&updatedAt=1670401923863"
            }
            className="absolute bottom-0 w-full"
          />
        </div>}
        <div className="text-sm md:text-lg md:w-1/2 mt-4">Challenge: Complete this micro-skill in 24 hours and get this certificate 👆 for <span className="font-bold">free!</span> </div>
        <div className="my-2 flex w-full items-center justify-between md:w-1/2 md:flex-row">
            <button
            className=" w-1/2 mr-1 py-2 text-sm md:text-lg rounded-md border-2  border-[#13B284]  font-semibold text-[#13B284]"
            onClick={() => {
                setStepOne(true);
            }}
            >
            I Can’t
            </button>
            <button
            className=" my-2 w-1/2 ml-1 py-2 text-sm flex justify-center items-center md:text-lg border-2 bg-[#13B284] border-[#13B284] rounded-md  font-semibold text-white "
            onClick={() => {
                Mixpanel.track(Constants.Mixpanel.ACCEPTED_CHALLENGE, {
                distinct_id: email,
                });
                createChallengeHandler();
            }}
            >
            {challengeSpinner ? (
                <CircularSpinner className={"scale-75"} />
            ) : (
                "Start Challenge"
            )}
            </button>
          
        </div>
      </div>
    );
  } else if(stepOne){
    return (
        <div
          className="flex h-full w-full flex-col items-center justify-evenly py-5 text-center backdrop-blur-lg"
          style={{ zIndex: 4 }} ref={oneDayScrollRef}
        >
          <div className="text-lg w-11/12 md:w-1/2 md:text-2xl font-bold">
          {user_name?.split(" ")?.[0]}, <span className="text-[#2BBD13]">{randomNumber?.daily_count}</span> learners have completed it today & so can you!</div>
          <div className="text-sm w-11/12 md:w-1/2 md:text-lg mt-2 md:mt-4">
          It’s quick, you’ll learn something new & get this certificate for free. So why not try?
          </div>
          {certificateLink &&<div className="relative mt-2 w-11/12 md:w-1/2 md:mt-4">
            <img src={certificateLink} className="w-full" alt="certificate link" ></img>
            <img
              urlEndpoint="https://assets.learntube.ai/files/"
              src={
                "https://assets.learntube.ai/files/Content_player/Certificate_overlay.png?ik-sdk-version=javascript-1.4.3&updatedAt=1670401923863"
              }
              className="absolute bottom-0 w-full"
            />
          </div>}
          {/* <div className="text-sm mt-2">Challenge: Complete this micro-skill in 24 hours and get this certificate 👆 <span className="font-bold">free!</span> </div> */}
          <div className="my-2 md:my-4 flex w-full items-center justify-between md:w-1/2 md:flex-row">
              <button
              className=" w-1/2 mr-1 py-2 text-sm md:text-lg rounded-md border-2  border-[#13B284]  font-semibold text-[#13B284]  "
              onClick={() => {
                  setStepOne(false);
                  setStepTwo(true);
                  
              }}
              >
              Pay for Certificate
              </button>
              <button
              className=" my-2 w-1/2 ml-1 py-2 text-sm flex justify-center items-center  md:text-lg rounded-md border-2 bg-[#13B284] border-[#13B284] font-semibold text-white"
              onClick={() => {
                  Mixpanel.track(Constants.Mixpanel.ACCEPTED_CHALLENGE, {
                  distinct_id: email,
                  });
                  createChallengeHandler();
              }}
              >
              {challengeSpinner ? (
                  <CircularSpinner className={"scale-75"} />
              ) : (
                  "Start Challenge"
              )}
              </button>
            
          </div>
        </div>
      );
  }
  else{
    return (
        <div
          className="flex h-full w-full flex-col items-center justify-evenly py-5 text-center backdrop-blur-lg"
          style={{ zIndex: 4 }} ref={oneDayScrollRef}
        >
          <div className="text-lg  w-11/12 md:w-1/2 md:text-2xl font-bold">
          {user_name?.split(" ")?.[0]}, <span className="text-[#2BBD13]">{randomNumber?.daily_count}</span> learners have completed it today & so can you!
          </div>
          <div className="text-sm w-11/12 md:w-1/2 md:text-lg  mt-2 md:mt-4">
          It’s quick, you’ll learn something new & get this certificate for free. So why not try?
          </div>
          {certificateLink &&<div className="relative mt-2 w-11/12 md:w-1/2 md:mt-4">
            <img src={certificateLink} className=" w-full" alt="certificate link" ></img>
            <img
              urlEndpoint="https://assets.learntube.ai/files/"
              src={
                "https://assets.learntube.ai/files/Content_player/Certificate_overlay.png?ik-sdk-version=javascript-1.4.3&updatedAt=1670401923863"
              }
              className="absolute bottom-0 w-full"
            />
          </div>}
          {/* <div className="text-sm mt-2">Challenge: Complete this micro-skill in 24 hours and get this certificate 👆 <span className="font-bold">free!</span> </div> */}
          <div className="my-2 md:my-4 flex w-full items-center justify-between md:w-1/2 md:flex-row">
              <button
              className=" w-1/2 mr-1 py-2 text-sm md:text-lg rounded-md border-2 border-[#86efac]  font-semibold text-[#86efac]"
              disabled
              >
              Pay for Certificate
              </button>
              <button
              className=" my-2 w-1/2 ml-1 py-2 text-sm  flex justify-center items-center md:text-lg rounded-md border-2  border-[#13B284] bg-[#13B284] font-semibold text-white"
              onClick={() => {
                  Mixpanel.track(Constants.Mixpanel.ACCEPTED_CHALLENGE, {
                  distinct_id: email,
                  });
                  setChallengeSpinner2(true);
                  createChallengeHandler(setChallengeSpinner2);
              }}
              >
              {challengeSpinner2 ? (
                  <CircularSpinner className={"scale-75"} />
              ) : (
                  "Start Challenge"
              )}
              </button>
            
          </div>
           <div className="text-sm w-11/12 md:w-1/2 md:text-lg">
                Are you sure? This is your <span className="text-[#E34D30]">last chance</span> to get this <span className="font-bold">certificate for free.</span>
            </div>
            <div className="my-2 flex w-11/12 md:w-2/5 items-center justify-between md:w- md:flex-row">
              <button
              className=" w-1/2 mr-1 py-2 text-xs md:text-sm rounded-md border-2  border-[#E34D30]  font-semibold text-[#E34D30]  "
              onClick={() => {
                 
                  if (userId) {
                    setOneDayChallengeActivity(true);
                    dispatch(declineChallenge(userId, mskill_slug));
                    setChallengeModal(true);
                    setChallengePopover(false);
                    setUserAlreadyTakenChallenge(true)
                    Mixpanel.track(Constants.Mixpanel.DECLINED_CHALLENGE, {
                        distinct_id: email
                    })
                    navigate('/pricing')
                } else {
                    navigate('/login', {
                        state: {
                            from: {
                                pathname: `/${course_slug}/${skill_slug}/${mskill_slug}/${lessonId}`,
                            },
                        },
                    });
                }
              }}
              >
              I'd Rather Pay
              
              </button>
              <button
              className=" my-2 w-1/2 ml-1 py-2 border-2 flex justify-center items-center  border-[#13B284] bg-[#13B284] text-xs md:text-sm rounded-md  font-semibold text-white"
              onClick={() => {
                  Mixpanel.track(Constants.Mixpanel.ACCEPTED_CHALLENGE, {
                  distinct_id: email,
                  });
                  setChallengeSpinner1(true);
                  createChallengeHandler(setChallengeSpinner1);
              }}
              >
              {challengeSpinner1 ? (
                  <CircularSpinner className={"scale-75"} />
              ) : (
                 "I'll Try"
              )}
              </button>
            
          </div>

        </div>
      );

  }
}
    // (
    //     <div className="w-full h-full backdrop-blur-lg flex flex-col justify-evenly items-center text-center py-5" style={{ zIndex: 4 }}>
    //         <img
    //             urlEndpoint="https://assets.learntube.ai/files/"
    //             src='https://assets.learntube.ai/files/Content_player/userSelectedNo.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1661246806388'
    //             className="w-full h-56 md:w-full md:h-56 mt-6"
    //             transformation={[{
    //                 "height": "160",
    //                 "width": "160",
    //             }]}
    //         />
    //         <div className="my-3">
    //             <h2 className="md:text-2xl text-lg font-bold mb-3">60,000+ learners have completed it & so can {name}!</h2>
    //             <span className="text-sm md:text-lg my-2">
    //                 What’s the harm anyway? You get a free certificate & learn something new! Come on, give it a shot.
    //             </span>
    //         </div>
    //         <div className="flex md:w-2/4 w-full md:flex-row flex-col justify-between items-center my-2">
    //             <button
    //                 className="bg-[#FDBF48] mx-4 flex justify-center items-center md:mx-0 my-2 md:my-0 p-2 w-3/4 md:w-40 text-white font-semibold rounded-md border-2 border-[#FDBF48]"
    //                 onClick={() => {
    //                     Mixpanel.track(Constants.Mixpanel.ACCEPTED_CHALLENGE, {
    //                         distinct_id: email
    //                     })
    //                     createChallengeHandler()
    //                 }}
    //             >
    //                 {challengeSpinner ? (
    //                     <CircularSpinner className={'scale-75'} />
    //                 ) : (
    //                     'Start Challenge'
    //                 )}
    //             </button>
    //             <button
    //                 className="font-semibold border-2 w-3/4 md:w-32 mx-4 md:mx-0 border-[#FDBF48] p-2 rounded-md text-[#FDBF48]"
    //                 onClick={() => {
    //                     if (userId) {
    //                         dispatch(declineChallenge(userId, mskill_slug));
    //                         setChallengeModal(true);
    //                         setChallengePopover(false);
    //                         setUserAlreadyTakenChallenge(true)
    //                         setDeclineChallengeModal(false)
    //                         Mixpanel.track(Constants.Mixpanel.DECLINED_CHALLENGE, {
    //                             distinct_id: email
    //                         })
    //                         navigate(`/${nextLesson?.nextLessonDetails}`)
    //                     } else {
    //                         navigate('/login', {
    //                             state: {
    //                                 from: {
    //                                     pathname: `/${course_slug}/${skill_slug}/${mskill_slug}/${lessonId}`,
    //                                 },
    //                             },
    //                         });
    //                     }
    //                 }}
    //             >
    //                 I Can't
    //             </button>
    //         </div>
    //     </div>
    // )
 

